var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAttributesGenerateImage = function SvgAttributesGenerateImage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.563,
    height: 25.563,
    viewBox: "565.718 139.801 25.563 25.563",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.122 154.96v-3.566c0-.165.133-.298.297-.298h1.189c.164 0 .297.133.297.298v3.567a.892.892 0 0 0 1.784 0v-3.567a2.08 2.08 0 0 0-2.081-2.081h-1.19a2.08 2.08 0 0 0-2.08 2.08v3.568a.892.892 0 0 0 1.784 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.878 150.205v4.756a.892.892 0 0 0 1.783 0v-4.756a.892.892 0 0 0-1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.525 147.827a3.27 3.27 0 0 0-3.27-3.27h-9.511a3.27 3.27 0 0 0-3.27 3.27v9.512a3.27 3.27 0 0 0 3.27 3.27h9.512a3.27 3.27 0 0 0 3.27-3.27v-9.512Zm-1.783 0v9.512c0 .82-.666 1.486-1.486 1.486h-9.512c-.82 0-1.487-.666-1.487-1.486v-9.512c0-.82.666-1.487 1.487-1.487h9.512c.82 0 1.486.666 1.486 1.487Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.797 152.285h-3.567a.892.892 0 0 0 0 1.784h3.567a.892.892 0 0 0 0-1.784Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.634 153.474h4.756a.892.892 0 0 0 0-1.783h-4.756a.892.892 0 0 0 0 1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.391 145.449v-4.756a.892.892 0 0 0-1.783 0v4.756a.892.892 0 0 0 1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.608 159.717v4.756a.892.892 0 0 0 1.783 0v-4.756a.892.892 0 0 0-1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.366 151.69h-4.756a.892.892 0 0 0 0 1.784h4.756a.892.892 0 0 0 0-1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.634 149.907h2.972a.892.892 0 0 0 0-1.783h-2.972a.892.892 0 0 0 0 1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.824 145.449v-2.973a.892.892 0 0 0-1.783 0v2.973a.892.892 0 0 0 1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.04 159.717v2.972a.892.892 0 0 0 1.784 0v-2.972a.892.892 0 0 0-1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.366 148.124h-2.973a.892.892 0 0 0 0 1.783h2.973a.892.892 0 0 0 0-1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.634 157.041h2.972a.892.892 0 0 0 0-1.783h-2.972a.892.892 0 0 0 0 1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.958 145.449v-2.973a.892.892 0 0 0-1.783 0v2.973a.892.892 0 0 0 1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.175 159.717v2.972a.892.892 0 0 0 1.783 0v-2.972a.892.892 0 0 0-1.783 0Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.366 155.258h-2.973a.892.892 0 0 0 0 1.783h2.973a.892.892 0 0 0 0-1.783Z",
    fill: "#c4464a",
    fillRule: "evenodd",
    "data-name": "Path 9477"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttributesGenerateImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attributes-generate-image.7462b779.svg";
export { ForwardRef as ReactComponent };